<template>
  <div class="auth-page">
    <b-card class="auth-card">
      <div class="auth-logo"></div>
      <h3 class="text-center mt-3">Орёл Туристический</h3>
      <p class="text-center text-muted">Вход в панель управления</p>
      <form class="mt-3" autocomplete="on" @submit.prevent="onSubmit">
        <b-form-input
          v-model="email"
          required
          name="username"
          type="email"
          autocomplete="username"
          placeholder="Электронная почта"
        />
        <b-form-input
          v-model="password"
          required
          name="password"
          type="password"
          autocomplete="current-password"
          class="mt-2"
          placeholder="Пароль"
        />
        <b-button type="submit" class="w-100 mt-2" variant="primary">
          Войти
        </b-button>
      </form>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'AuthLayout',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    ...mapActions('auth', ['ActionLogin']),
    async onSubmit() {
      try {
        await this.ActionLogin(this.$data);
        await this.$router.push({ name: 'Admin' });
      } catch (e) {
        this.$bvToast.toast(e.message, { variant: 'danger' });
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.auth-page {
  display: flex;
  width: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at 20% 15%, rgba(200, 12, 11, 0.1), transparent 30%),
    #f5f6f8;
}

.auth-card {
  width: 100%;
  max-width: 410px;
  padding: 22px;
  border: 0;
  box-shadow: 0 18px 50px rgba(31, 35, 48, 0.12);
}

.auth-logo {
  width: 58px;
  height: 58px;
  margin: 0 auto;
  background-image: url(../assets/logo.png);
  background-position: center;
  background-size: cover;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(150, 5, 5, 0.2);
}
</style>
